// @ts-nocheck
import _ from './imports/lodash-imports';
const domain = _.replace(
  _.replace(_.replace(window.location.origin, 'http://', ''), 'https://', ''),
  '/',
  ''
);

const isProduction = domain === 'quote.petsy.com.au';
// const isProduction = false;

window.flowSettings = {};
window.flowSettings.isTest = !isProduction; //true;

if (window.flowSettings.isTest) console.log('TEST MODE ', domain);
else console.log('PRODUCTION MODE', domain);

export default {
  knose_portal_api_url:
    'https://' +
    (domain === 'quote.petsy.com.au' ? 'portal.knose.com.au' : (domain === 'quote.test.petsy.com.au' ? 'uat.origami-calc.knose.com.au' : 'uat.knose.com.au')) +
    '/OrigamiKnose/web/',
  knose_portal_api_url_test: 'https://portal.knose.com.au/OrigamiKnose/web/',
  middleman_api_url: 'https://' +
    (domain === 'quote.petsy.com.au' ? 'middleman.knose.com.au' : (domain === 'quote.test.petsy.com.au' ? 'middleman-st.knose.com.au' : 'middleman-st.knose.com.au')) +
    '/api/v1',
  middleman_api_key: window.flowSettings.isTest
    ? 'jfAWdDm9xS7bU5MYKsKK5SpJZ5RAB62N'
    : 'AJMHsjB49LqDQrQeaY87shwH3TbWw4ke',
  action_get_breeds: '/category/pet-breed',
  action_check_promotion: 'premium/promo/code/validate',
  action_calculate_payment: 'premium/unified-calculate',
  action_checkout_payment: 'premium/unified-bind-batch',
  action_notify: 'premium/notify',
  action_issue_batch: 'premium/issue-batch',
  action_bind_batch: 'premium/unified-bind-batch',
  action_quote_email: 'premium/email/',
  action_get_sales_journey_info: 'sales/journey/info/',
  action_get_customer_info: 'sales/customer/info/',
  payway_api_key: window.flowSettings.isTest
    ? 'T17438_PUB_hrv693mt68hdgiqfs9p4g7mpfshp3nen9qg28qbpc5cnqxtr6n4yvysuvaq7'
    : 'Q26254_PUB_k2gy728sh9fccprtyhusbp2t4xgbxu3qc6tdvz9pviebwvq9vbg4spe47b52',
  wait_url:
    domain +
    '/' +
    (window.flowSettings.isLocal ? 'wait-dev.json' : 'wait.json'),
  exit_timer: window.flowSettings.isLocal ? 15 : 30, // seconds
  policy_limit_end_date: 21, // Max limnit days for policy end date
  policy_limit_start_date: 6, // Max limnit weeks for policy start date
  soreto_key: '5e971872488d483f4c6ea969',
  google_site_key: '6LeoAaAcAAAAAHWe7m8yqEwLwGoE8dgARQ3ykApj',
  maintenance_mode: false,
  quote_version: '1.2.17',

  flow_logger_endpoint: window.flowSettings.isTest
    ? 'https://n2rerp6hd8.execute-api.ap-southeast-2.amazonaws.com/default/petsy-quote-log-uat'
    : 'https://5hfx8ro4m1.execute-api.ap-southeast-2.amazonaws.com/default/petsy-quote-log-uat',

  flow_telemetry_endpoint: domain === 'quote.petsy.com.au'
    ? 'https://api.petsy.com.au/telemetry'
    : (domain === 'quote.test.petsy.com.au' ? 'https://api.test.petsy.com.au/telemetry' : 'https://api.staging.petsy.com.au/telemetry'),

  // Petsy
  websevice_timeout: 180000, //18000,
  trackingApiKey: window.flowSettings.isTest
    ? 'sjA1V76Dto4GFl6kTTsom43XAWwfSgnV2tSKqmFJ'
    : 'QQwrlkzi4z3s9LgqTZfND9b1gHY7d557axblijPb',
  trackingApiUrl: window.flowSettings.isTest
    ? 'https://api.staging.petsy.com.au/petsy'
    : 'https://api.petsy.com.au/petsy',
  knose_alternate_quotes_api_url: window.flowSettings.isTest ? 'https://petsy-st.knose.com.au/v1/quote-ranges/petsy' : 'https://petsy-prd.knose.com.au/v1/quote-ranges/petsy',
  knose_alternate_quotes_api_key: window.flowSettings.isTest ? 'EF9C53C24BE5FA7F469C5697EE6CF2B7' : 'F6F28DF9742EE2D4692F8FCEFAF7F7FD'
};

// export default {
//   knose_portal_api_url:
//     'https://portal.knose.com.au/OrigamiKnose/web/',
//   knose_portal_api_url_test: 'https://portal.knose.com.au/OrigamiKnose/web/',
//   middleman_api_url: 'https://middleman.knose.com.au/api/v1',
//   action_get_breeds: '/category/pet-breed',
//   action_check_promotion: 'premium/promo/code/validate',
//   action_calculate_payment: 'premium/unified-calculate',
//   action_checkout_payment: 'premium/unified-bind-batch',
//   action_notify: 'premium/notify',
//   action_issue_batch: 'premium/issue-batch',
//   action_bind_batch: 'premium/unified-bind-batch',
//   action_quote_email: 'premium/email/',
//   action_get_sales_journey_info: 'sales/journey/info/',
//   action_get_customer_info: 'sales/customer/info/',
//   payway_api_key: 'Q26254_PUB_k2gy728sh9fccprtyhusbp2t4xgbxu3qc6tdvz9pviebwvq9vbg4spe47b52',
//   wait_url:
//     domain +
//     '/' +
//     (window.flowSettings.isLocal ? 'wait-dev.json' : 'wait.json'),
//   exit_timer: window.flowSettings.isLocal ? 15 : 30, // seconds
//   policy_limit_end_date: 21, // Max limnit days for policy end date
//   policy_limit_start_date: 6, // Max limnit weeks for policy start date
//   soreto_key: '5e971872488d483f4c6ea969',
//   google_site_key: '6LeoAaAcAAAAAHWe7m8yqEwLwGoE8dgARQ3ykApj',
//   maintenance_mode: false,
//   quote_version: '1.2.17',

//   flow_logger_endpoint: 'https://5hfx8ro4m1.execute-api.ap-southeast-2.amazonaws.com/default/petsy-quote-log-uat',

//   flow_telemetry_endpoint: 'https://api.petsy.com.au/telemetry',

//   // Petsy
//   websevice_timeout: 25000, //18000,
// };
